module.exports = __webpack_public_path__ + "static/img/2.6e8b797d.png";